import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { HttpErrorResponse } from "../../../types/responses";
import { useApiPssAddAssigneeDetails } from "../datasources/_pss.assignee-details.api.slice";

const usePssAddAssigneeDetailsRepo = () => {
  const [api, repository] = useApiPssAddAssigneeDetails();
  const httpError = repository.error
    ? ((repository.error as FetchBaseQueryError).data as HttpErrorResponse)
    : undefined;

  return [
    {
      ...repository,
      error: httpError,
    },
    api,
  ] as const;
};

export default usePssAddAssigneeDetailsRepo;
